import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { setLoadingEvent, setEvent } from '../../features/event/eventSlice';

import { doc, onSnapshot } from 'firebase/firestore';
import { store } from '../../config/firebase';
import { useColorMode } from '../../hooks/colorModeProvider';
import EmbeddedDetailedSectionsView from './sectionsDetailed';
import EmbeddedDetailedLogsView from './logsDetailed';
import EmbeddedBracketView from './bracketView';
import { Box } from '@mui/material';

const EmbeddedScores = () => {
  const dispatch = useDispatch();
  const event = useSelector((state) => state.event.event);
  const loadingEvent = useSelector((state) => state.event.loadingEvent);
  const { mode, setMode } = useColorMode();

  useEffect(() => {
    setMode('light');
  }, [mode, setMode]);

  //Get Event ID from params.
  const { eventId } = useParams();
  const [searchParams] = useSearchParams();

  //Get event by eventId
  useEffect(() => {
    if (!eventId) return;

    dispatch(setLoadingEvent(true));
    const docRef = doc(store, 'events', eventId);

    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const eventData = { id: docSnap.id, ...docSnap.data() };
        dispatch(setEvent(eventData));
      } else {
        console.log('No such document!');
      }
      dispatch(setLoadingEvent(false));
    });

    return () => unsubscribe();
  }, [eventId, dispatch]);

  const getView = () => {
    if (!event) return null;

    const eventSpecialty = event.specialty || event.speciality;
    const ignoreSpecialtyRaw =
      searchParams.get('ignorespecialty') ||
      searchParams.get('ignoreSpecialty') ||
      searchParams.get('ignorespeciality') ||
      searchParams.get('ignoreSpeciality') ||
      '';
    const ignoreSpecialty = ['true', '1', 'yes'].includes(
      String(ignoreSpecialtyRaw).trim().toLowerCase()
    );

    if (
      String(eventSpecialty || '')
        .trim()
        .toLowerCase() === 'fairtree cup' &&
      !ignoreSpecialty
    ) {
      return <Navigate to={`/embed/groupmatch/${eventId}`} replace />;
    }

    if (event.hasBracketOnly || event.specialty) {
      return <EmbeddedBracketView />;
    }

    if (event.hasSections) {
      return <EmbeddedDetailedSectionsView />;
    } else {
      return <EmbeddedDetailedLogsView />;
    }
  };

  return loadingEvent ? <Box>Loading...</Box> : getView();
};

export default EmbeddedScores;
